var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEventAction(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 6,
    viewBox: "0 0 24 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 3C18 4.65 19.35 6 21 6C22.65 6 24 4.65 24 3C24 1.35 22.65 -5.90104e-08 21 -1.31134e-07C19.35 -2.03258e-07 18 1.35 18 3ZM15 3C15 1.35 13.65 -4.52413e-07 12 -5.24537e-07C10.35 -5.9666e-07 9 1.35 9 3C9 4.65 10.35 6 12 6C13.65 6 15 4.65 15 3ZM6 3C6 1.35 4.65 -8.45815e-07 3 -9.17939e-07C1.35 -9.90063e-07 -5.90104e-08 1.35 -1.31134e-07 3C-2.03258e-07 4.65 1.35 6 3 6C4.65 6 6 4.65 6 3Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEventAction);
export default __webpack_public_path__ + "static/media/eventAction.5118edae83dd0a7c56836d1670ef9be7.svg";
export { ForwardRef as ReactComponent };